import {Outlet, useLocation, useParams} from "react-router-dom";
import {useAuth} from "../contexts/AuthContext";
import ErrorPage from "../pages/ErrorPage.tsx";
import {UserRole} from "@/types/UserRole.ts";

type ProtectedRouteWithIdProps = {
    roleType?: UserRole;
};

const ProtectedRouteWithId = ({ roleType }: ProtectedRouteWithIdProps) => {
    const { loggedInUser } = useAuth();
    const { id } = useParams<{ id: string }>();
    const location = useLocation();
    const currentPath = location.pathname + location.search;

    if (!loggedInUser) {
        window.location.href = `/auth/ibmid?redirectTo=${encodeURIComponent(currentPath)}`; // Redirect to the backend authentication route
        return null;
    }

    let allowedId;
    if (roleType === UserRole.ADMIN) {
        allowedId = loggedInUser.id;
    } else if (roleType === UserRole.MENTOR) {
        allowedId = loggedInUser.mentor?.id;
    } else if (roleType === UserRole.MENTEE) {
        allowedId = loggedInUser.mentee?.id;
    }

    // Check if the user is an admin or has the matching ID
    if (loggedInUser.role === UserRole.ADMIN || (allowedId && allowedId.toString() === id)) {
        return <Outlet />;
    }

    return <ErrorPage />;
};

export default ProtectedRouteWithId;
